import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div<{ $banner?: boolean }>`
	display: grid;
	grid-template-columns: ${(props) => (props.$banner ? '600px 1fr' : '1fr')};
	gap: 20px;
	padding: 0 40px 40px;
`;

const StyledRightContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 18px;
`;

const StyledCategoryItem = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

const StyledCategory = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: fit-content;
	height: 20px;
	padding: 0 5px;
	background: rgba(255, 255, 255, 0.1);
	border-radius: 5px;

	${Text} {
		font-weight: 700;
		font-size: 12px;
		color: #ffffff;
	}
`;

const StyledCasesContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(290px, 1fr));
	gap: 20px;
`;

const StyledKitsContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(290px, 1fr));
	gap: 20px;
`;

export {
	StyledCasesContainer,
	StyledCategory,
	StyledCategoryItem,
	StyledContainer,
	StyledKitsContainer,
	StyledRightContainer,
};
